// **************************************************
import { Injectable } from '@angular/core';
import { UserApiService } from './user-api.service';
import { TaminServiceReturnModel } from '../models/electronic-prescription/tamin-service-return-model';
import { LoggerService } from 'src/app/services/logger.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { GetActivePrescriptionViewModel } from '../models/electronic-prescription/get-active-prescription-view-model';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { PrescriptionDrug } from '../models/electronic-prescription/prescription-drug';
import { PrescriptionDrugStock } from '../models/electronic-prescription/prescription-drug-stock';
import { Referral } from '../models/electronic-prescription/referral';
// **************************************************

@Injectable({
  providedIn: 'root',
})
export class SalamatService {
  constructor(
    private calenderService: NewCalendarService,
    private apiService: UserApiService,
    private logger: LoggerService
  ) {}

  private CitizenToken?: string;

  public GetPrescription(
    nationalCode: string,
    trackingCode: string
  ): Promise<Referral> {
    return new Promise((resolve, reject) => {
      try {
        if (this.CitizenToken == '') {
          this.CitizenToken = undefined;
        }
        const backendUrl = `SaleElectronicPrescription/GetPrescription`;

        let backEndJson = new GetActivePrescriptionViewModel(4);

        backEndJson.nationalCode = nationalCode;
        backEndJson.trackingCode = trackingCode;
        backEndJson.citizenToken = this.CitizenToken;

        if (
          !this.apiService.tokenValidation(
            new ApiRequestModel(backendUrl, backEndJson)
          )
        ) {
          reject();
        }

        this.apiService
          .postItem(new ApiRequestModel(backendUrl, backEndJson))
          .subscribe(
            (result) => {
              if (result.succeeded == false) {
                this.logger.addBackEndMessage(result);
                reject(result);
                return;
              }

              var referral = this.mapResult(result.data);
              resolve(referral);
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              reject(error);
            }
          );
      } catch (error) {
        this.logger.addError(error, false);
        reject(error);
      }
    });
  }

  private mapResult(result: Referral) {
    this.CitizenToken = result.citizenToken;
    if (result.prescriptionDate != undefined) {
      result.prescriptionDate = this.calenderService.ToGregorianDateTime(
        result.prescriptionDate!
      );
    }

    // result.prescriptions.forEach((prescription) => {
    //   prescription.drugs.forEach((drug) => {
    //     drug.stock.loading = true;
    //     try {
    //       const inventoryUrl = `SaleElectronicPrescription/Salamat/GetInventoryDrug?drugCode=${drug.genericCodeString}&count=${drug.requestCount}`;
  
    //       if (!this.apiService.tokenValidation(new ApiRequestModel(inventoryUrl))) {
    //         return;
    //       }
  
    //       this.apiService
    //         .getSingleItem(new ApiRequestModel(inventoryUrl))
    //         .subscribe(
    //           (result) => {
    //             if (result.succeeded == false) {
    //               this.logger.addBackEndMessage(result);
    //               return;
    //             }
  
    //             drug.stock=result.data;
    //             const drugPrice:number=drug.stock.patientSharePrice??0;
    //             drug.organizationSharePrice=drug.organizationSharePrice??0;
    //             drug.stock.patientSharePrice=drugPrice-drug.organizationSharePrice;
    //             drug.stock.insuranceSharePrice=drug.organizationSharePrice;
    //             drug.stock.loading=false;
    //           },
    //           (error) => {
    //             this.apiService.AddErrorLog(error);
    //             drug.stock.loading=false;
    //             return;
    //           }
    //         );
    //     } catch (error) {
    //       this.logger.addError(error, false);
    //       return;
    //     }
    //   });
    // });

    return result;
  }

  public GetDrugDetails(
    drug: PrescriptionDrug
  ): Promise<PrescriptionDrugStock> {
    return new Promise((resolve, reject) => {
      try {
        const inventoryUrl = `SaleElectronicPrescription/Salamt/GetInventoryDrug?drugCode=${drug.genericCodeString}&count=${drug.requestCount}&isHospitalDrug=${drug.hospitalDrug == '1' ? true : false}&neededToHaveFile=${drug.neededToHaveFile == '1' ? true : false}&shouldSendToEsalat=${drug.shouldSendToEsalat}`;

        if (!this.apiService.tokenValidation(new ApiRequestModel(inventoryUrl))) {
          reject();
        }

        this.apiService
          .getSingleItem(new ApiRequestModel(inventoryUrl))
          .subscribe(
            (result) => {
              if (result.succeeded == false) {
                this.logger.addBackEndMessage(result);
                reject(result);
              }

              result.data.loading = false;
              resolve(result.data);
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              reject(error);
            }
          );
      } catch (error) {
        this.logger.addError(error, false);
        reject(error);
      }
    });
  }
  public GetDrugDetailsVersionOne(
    drug: PrescriptionDrug
  ): Promise<PrescriptionDrugStock> {
    return new Promise((resolve, reject) => {
      try {
        const backendUrl = `SaleElectronicPrescription/Tamin/GetInventoryDrug?drugCode=${drug.genericCodeString}&count=${drug.requestCount}&isHospitalDrug=${drug.hospitalDrug == '1' ? true : false}&neededToHaveFile=${drug.neededToHaveFile == '1' ? true : false}&shouldSendToEsalat=${drug.shouldSendToEsalat}`;

        if (!this.apiService.tokenValidation(new ApiRequestModel(backendUrl))) {
          reject();
        }

        this.apiService
          .getSingleItem(new ApiRequestModel(backendUrl))
          .subscribe(
            (result) => {
              if (result.succeeded == false) {
                this.logger.addBackEndMessage(result);
                reject(result);
              }

              result.data.loading = false;
              resolve(result.data);
            },
            (error) => {
              this.apiService.AddErrorLog(error);
              reject(error);
            }
          );
      } catch (error) {
        this.logger.addError(error, false);
        reject(error);
      }
    });
  }
}
